/** @format */

import axios from 'axios';
import dustConfig from './dust.config';

const axiosInstance = axios.create({
  baseURL: dustConfig.dustLogServiceUrl,
});

axiosInstance.interceptors.request.use(
  config => {
    let { data } = config;
    data = {
      timestamp: new Date().getTime(),
      ...dustConfig.globalConfig,
      ...data,
    };
    config.data = data;

    return config;
  },
  error => {
    Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(
  response => {
    return response.data;
  },
  error => {
    return Promise.reject(error);
  },
);

export { axiosInstance as dust };
